import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface NavigationState {
  isRadioPlaying: boolean
  isRadioBusy: boolean
  shouldDisableTabNavigationRender: boolean
}

const commonInitialState: NavigationState = {
  isRadioPlaying: false,
  isRadioBusy: false,
  shouldDisableTabNavigationRender: false,
}

const navigationSlice = createSlice({
  name: 'navigation',
  initialState: commonInitialState,
  reducers: {
    setRadioPlaying(state, action: PayloadAction<boolean>) {
      state.isRadioPlaying = action.payload
    },

    setIsRadioBusy(state, action: PayloadAction<boolean>) {
      state.isRadioBusy = action.payload
    },

    setDisableTabNavigationRender(state, action: PayloadAction<boolean>) {
      state.shouldDisableTabNavigationRender = action.payload
    },
  },
})

export const { setRadioPlaying, setIsRadioBusy, setDisableTabNavigationRender } =
  navigationSlice.actions

export default navigationSlice.reducer
